import Image3 from './Resources/image-3.png'
import { Link, Box, Typography, styled } from '@mui/material'
import config from 'config'

const RootContainer = styled('div')(({ theme }) => ({
    backgroundColor: '#eef0f4',
    textAlign: 'center',
    '& img': {
        margin: 'auto',
        marginTop: '6vw',
        maxWidth: '100%',
    },
}))

const ContentContainer = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        marginTop: '-15%',
    },
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'wrap',
    textAlign: 'center',
    background: 'transparent',
    left: 0,
    right: 0,
}))

const FooterContainer = styled(Box)({
    maxWidth: 550,
    marginTop: '-4.5rem',
    margin: 'auto',
    left: 0,
    right: 0,
})

const NotFoundContainer = styled(Box)(({ theme }) => ({
    marginTop: '-6.5rem',
    [theme.breakpoints.down('xl')]: {
        marginTop: '-3rem',
    },
}))

const NotFoundText = styled(Typography)({
    color: '#3f3767',
    fontWeight: '300',
    fontSize: '16vw',
})

const NotFoundPage = (props) => {
    const { description, linkText, errorCode } = props

    return (
        <RootContainer>
            <img
                src={`${config.APP_SUBPATH}${Image3}`}
                alt=""
                aria-hidden="true"
            />

            <ContentContainer>
                <NotFoundContainer>
                    <NotFoundText>{errorCode}</NotFoundText>
                </NotFoundContainer>
            </ContentContainer>
            <FooterContainer>
                <Box sx={{ marginTop: '4vh' }}>
                    <Box>
                        <Typography sx={{ fontSize: '2.2rem' }}>
                            {description}
                        </Typography>
                    </Box>
                    <Box sx={{ marginTop: '2rem' }}>
                        <Link
                            component="a"
                            underline="none"
                            href={`${config.APP_SUBPATH}/`}
                        >
                            <Typography
                                sx={{
                                    color: '#453fbb',
                                    fontSize: '2.2rem',
                                }}
                            >
                                {linkText}
                            </Typography>
                        </Link>
                    </Box>
                </Box>
            </FooterContainer>
        </RootContainer>
    )
}

export default NotFoundPage
